import ElInputPro from './inputPro';

window.Vue && window.Vue.component('ElInputPro', ElInputPro)